// Utils
import localStorageService from '../../../utils/services/localStorage/localStorage';

const ONBOARDING_PROGRESS_LOCAL_STORAGE_KEY = 'milanote.onboarding.progress';

export const getOnboardingProgressStep = () => localStorageService.getItem(ONBOARDING_PROGRESS_LOCAL_STORAGE_KEY);
export const clearOnboardingProgressStep = () => localStorageService.removeItem(ONBOARDING_PROGRESS_LOCAL_STORAGE_KEY);
export const setOnboardingProgressStep = (stepId) =>
    localStorageService.setItem(ONBOARDING_PROGRESS_LOCAL_STORAGE_KEY, stepId);
